import React, { useContext, useState, useEffect, useMemo } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';
import { DynamicModalContext } from '../../../init/dynamicModals';

import { Col, Form, Row, InputGroup } from 'react-bootstrap';

import { Space, Input, Dropdown, Button, Spin, Tabs } from 'antd';
import Modal from 'react-bootstrap/Modal';

import { DownOutlined } from '@ant-design/icons';

import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcLock } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";
import { FaPlus } from "react-icons/fa";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../../components/loader/loader';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';

const InvoiceCart = (props) => {

    const { cart, setCart, selectedCurrency, cartItem, setJournalVoucher, idRow, journalVoucher, netCharges, setAllocateInvoice, allocateInvoice } = props;

    const { userData, settingData, salableOptions, salableData, loadSalableOptions, rateFromToCurrency, formLanguages } = useContext(DataContext);

    const { openAddProductModal } = useContext(DynamicModalContext);

    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const createdBy = parseInt(userData.id);

    const [loadingEffect, setLoadingEffect] = useState(false);
    const [spinning, setSpinning] = React.useState(false);
    const [scannedBarcode, setScannedBarcode] = useState("");


    useEffect(() => {
        if (!idRow) {
            setCart([cartItem])
            setJournalVoucher((prev) => ({
                ...prev,
                discountAmount: 0,
                discountPercentage: 0,
            }));
        }
    }, [selectedCurrency]);


    useEffect(() => {

        if (idRow?.isChargeAllocated === false || !idRow) {
            if (journalVoucher.isChargeAllocated === true) {
                runAddAllocation();
                setAllocateInvoice(true);
            }
            else if (allocateInvoice) {
                runRemoveAllocation();
                setAllocateInvoice(false);
            }
        }

        else if (idRow?.isChargeAllocated === true) {

            if (journalVoucher.isChargeAllocated === false) {
                runRemoveAllocation();
                setAllocateInvoice(false);
            }
            else if (allocateInvoice === false) {
                runAddAllocation();
                setAllocateInvoice(true);
            }
        }
    }, [journalVoucher.isChargeAllocated]);


    const runAddAllocation = () => {
        const totalCartValue = journalVoucher.credit;
        const updatedCart = cart.map((item, index) => {
            const itemValue = item.cost * item.quantity;
            const allocationPercent = itemValue / totalCartValue;
            const allocatedCharge = netCharges * allocationPercent;

            // Update the cost per unit by adding the allocated charge
            const updatedCost = parseFloat(parseFloat(item.cost) + parseFloat(allocatedCharge) / item.quantity) || 0;

            handleRowChange(index, updatedCost, 'cost')


        });
    }

    const runRemoveAllocation = () => {
        const totalCartValue = journalVoucher.credit;
        const updatedCart = cart.map((item, index) => {
            const itemValue = item.cost * item.quantity;
            const allocationPercent = itemValue / totalCartValue;
            const allocatedCharge = netCharges * allocationPercent;

            // Update the cost per unit by adding the allocated charge
            const updatedCost = parseFloat(parseFloat(item.cost) - parseFloat(allocatedCharge) / item.quantity) || 0;

            handleRowChange(index, updatedCost, 'cost')


        });
    }

    const items = useMemo(() =>
        [
            {
                label: 'Simple',
                key: '1',
                onClick: () => openAddProductModal('simple')
            },
            {
                label: 'Serialized',
                key: '2',
                onClick: () => openAddProductModal('serialized')
            }
        ]);

    // Add new row
    const handleAddRow = () => {
        setCart((prevCart) => [...prevCart, cartItem]);
    };

    // Delete VarientRow
    const handleDeleteRow = (event, type) => {
        event.preventDefault()

        if (cart.length > 1) {
            const updatedRows = cart.slice(0, -1);
            setCart(updatedRows);
        } else {
            toast.error('you need at least one item')
        }


    };

    const handleDeleteRowIndex = (index) => {
        const updatedRows = cart.filter((_, i) => i !== index);
        setCart(updatedRows);
    };

    // handle row changes
    const handleRowChange = (index, value, field) => {
        const updatedCart = [...cart];


        if (field == 'product') {
            updatedCart[index].productId = value.id;
            updatedCart[index].cost = rateFromToCurrency(value.currency, selectedCurrency, value.cost);
            updatedCart[index].units = value.units;
            updatedCart[index].unitQuantity = 1;
            updatedCart[index].quantity = 1;
            updatedCart[index].index = index;
            updatedCart[index].isStock = value.isStock;
            updatedCart[index].type = value.type;
            updatedCart[index].vatPercentage = value.vat;

            updatedCart[index].accountId = settingData.purchaseAccountId;



        } else if (field == 'cost') {
            updatedCart[index].cost = parseFloat(value);

        } else if (field == 'quantity') {
            updatedCart[index].quantity = value;

        } else if (field == 'unitQuantity') {
            updatedCart[index].unitQuantity = value.quantity;
            updatedCart[index].unitName = value.name;

        } else if (field == 'freeQuantity') {
            updatedCart[index].freeQuantity = value;

        } else if (field == 'details') {
            updatedCart[index].details = value;

        }
        else if (field == 'costDiscountAmount') {
            updatedCart[index].costDiscountAmount = value;
            updatedCart[index].costDiscountPercentage = (updatedCart[index].costDiscountAmount / (updatedCart[index].cost * updatedCart[index].quantity)) * 100;

        }
        else if (field == 'costDiscountPercentage') {
            updatedCart[index].costDiscountPercentage = value;
        }
        else if (field == 'vatPercentage') {
            updatedCart[index].vatPercentage = value;
        }

        updatedCart[index].subQuantity = updatedCart[index].quantity;
        updatedCart[index].netQuantity = parseFloat(updatedCart[index].subQuantity) + parseFloat(updatedCart[index].freeQuantity);

        updatedCart[index].costDiscountAmount = (updatedCart[index].costDiscountPercentage / 100) * (updatedCart[index].cost * (updatedCart[index].subQuantity * updatedCart[index].unitQuantity));

        const subCost = (updatedCart[index].cost * updatedCart[index].subQuantity) * updatedCart[index].unitQuantity;

        const totalCost = (subCost - updatedCart[index].costDiscountAmount);

        updatedCart[index].vatAmount = (updatedCart[index].vatPercentage / 100) * (totalCost);

        updatedCart[index].totalCost = totalCost;
        updatedCart[index].netCost = totalCost / (updatedCart[index].subQuantity * updatedCart[index].unitQuantity);

        if (updatedCart[index].subQuantity == 0) {
            updatedCart[index].netCost = updatedCart[index].cost;
        }

        setCart(updatedCart);
    }


    const handleBarcodeScan = (e) => {
        const barcode = e.target?.value;
        const product = salableOptions?.find(option => option.barcode === barcode);

        if (!product) {
            toast.error('Product not found');
            setScannedBarcode('');
            return;
        }

        setCart((prevCart) => {
            let updatedCart = [...prevCart];
            const existingProductIndex = updatedCart.findIndex(option => option.productId === product.id);

            if (existingProductIndex > -1) {
                let quantity = parseFloat(updatedCart[existingProductIndex].quantity) + parseFloat(1);
                handleRowChange(existingProductIndex, quantity, 'quantity');
            } else {
                // Add new product row
                const productItem = {
                    accountId: settingData?.purchaseAccountId,
                    productId: product.id,
                    cost: rateFromToCurrency(product.currency, selectedCurrency, product.cost),
                    units: product.units,
                    unitQuantity: 1,
                    unitName: product.defaultUnitName || '',   // 🆕
                    subQuantity: 1,
                    freeQuantity: 0,
                    costDiscountAmount: 0,
                    costDiscountPercentage: 0,
                    netQuantity: 1,
                    quantity: 1,
                    vatPercentage: product.vat,
                    isStock: product.isStock || false,         // 🆕
                    index: prevCart.length,                    // 🆕 (optional)
                    details: product.details || '',            // 🆕
                    type: product.type,
                };

                const subCost = productItem.cost * productItem.subQuantity * productItem.unitQuantity;
                const totalCost = subCost - productItem.costDiscountAmount;
                productItem.vatAmount = (productItem.vatPercentage / 100) * totalCost;
                productItem.totalCost = totalCost;
                productItem.netCost = totalCost / (productItem.subQuantity * productItem.unitQuantity);


                if (cart.length == 1 && !cart[0].productId) {
                    updatedCart = [productItem];
                } else {
                    updatedCart.push(productItem);
                }

            }

            return updatedCart;
        });

        setScannedBarcode('');
    };


    const editProduct = (productId) => {
        const product = salableData.find(product => product.id == productId);
        openAddProductModal(product.type, product);
    }


    // Generic handler for input changes
    const handleInputChange = (e) => {
        let { name, value } = e.target;
        setJournalVoucher((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    return (

        <div>

            <div style={journalVoucher.isChargeAllocated ? { pointerEvents: 'none', userSelect: 'none', opacity: 0.7 } : null}>

                <Spin spinning={spinning} fullscreen />


                <Row>
                    <Col md={2}>
                        <Form.Label style={{ display: "inline-block", marginRight: "10px" }}>
                            {formLanguages.SelectProducts}
                        </Form.Label>
                        <Dropdown menu={{ items }} trigger={['click']} overlayStyle={{ zIndex: 9999 }} transitionName="">
                            <a onClick={e => e.preventDefault()}>
                                <Space> <FaPlus style={{ marginTop: "-8px" }} size={15} /> </Space>
                            </a>
                        </Dropdown>
                    </Col>


                    <Col>
                        <Form.Label>{formLanguages.Unit}</Form.Label>
                    </Col>

                    <Col style={{ flex: 0.6 }}>
                        <Form.Label>{formLanguages.Quantity}</Form.Label>
                    </Col>

                    <Col style={{ flex: 0.6 }}>
                        <Form.Label>{formLanguages.FreeQty}</Form.Label>
                    </Col>

                    <Col>
                        <Form.Label>{formLanguages.UnitCost}</Form.Label>
                    </Col>

                    <Col style={{ flex: 0.6 }}>
                        <Form.Label>{formLanguages.Discount} %</Form.Label>
                    </Col>


                    <Col>
                        <Form.Label>{formLanguages.Discount}</Form.Label>
                    </Col>


                    <Col>
                        <Form.Label>{formLanguages.Total} {formLanguages.Cost}</Form.Label>
                    </Col>


                    <Col style={{ flex: 0.6 }}>
                        <Form.Label>{formLanguages.VAT} %</Form.Label>
                    </Col>

                    <Col>
                        <Form.Label>{formLanguages.Details}</Form.Label>
                    </Col>

                    <Col style={{ flex: 0.2 }}>
                    </Col>

                </Row>



                {cart.map((row, index) => (


                    <Row className="g-0 mb-1" key={index}>
                        <Col md={2}>
                            <AsyncSelect
                                cacheOptions
                                loadOptions={loadSalableOptions}
                                defaultOptions={[]}
                                onChange={(e) => handleRowChange(index, e, 'product')}
                                value={salableOptions?.find(option => option.value === cart[index].productId) || []}
                                noOptionsMessage={() => 'type to view'}
                                required
                            />
                        </Col>

                        {/* Units  Quantity*/}
                        <Col>
                            <Select
                                options={[
                                    {
                                        value: { name: "", quantity: 1 },
                                        label: `(x1)`
                                    },
                                    ...(cart[index]?.units?.map(unit => ({
                                        value: { name: unit.name, quantity: unit.quantity },
                                        label: `${unit.name} (x${unit.quantity})`
                                    })) || [])
                                ]}
                                onChange={(e) => handleRowChange(index, e.value, 'unitQuantity')}
                                defaultValue={{
                                    value: JSON.stringify({ name: cart[index]?.unitName, quantity: cart[index]?.unitQuantity }),
                                    label: `${cart[index]?.unitName} (x${cart[index]?.unitQuantity || 1})`
                                }}
                                className="react-select-sm"
                            />

                        </Col>

                        {/*  Quantity  */}
                        <Col style={{ flex: 0.6 }}>
                            <Form.Control type="number" min={0} step='any'
                                onChange={(e) => handleRowChange(index, e.target.value, 'quantity')}
                                style={{ backgroundColor: '#f0f8ff' }}
                                value={cart[index].quantity}
                                required
                            />
                        </Col>

                        {/*  Free Quantity  */}
                        <Col style={{ flex: 0.6 }}>
                            <Form.Control type="number" min={0} step='any'
                                onChange={(e) => handleRowChange(index, e.target.value, 'freeQuantity')}
                                style={{ backgroundColor: '#ebfadd' }}
                                value={cart[index].freeQuantity}
                                required
                            />
                        </Col>

                        {/* Cost */}
                        <Col>
                            <Form.Control type="number" min={0} step='any' value={cart[index].cost}
                                style={{ backgroundColor: '#f7e8e8' }}
                                onChange={(e) => handleRowChange(index, e.target.value, 'cost')}
                                required
                            />
                        </Col>

                        {/* discount % */}
                        <Col style={{ flex: 0.6 }}>
                            <Form.Control type="number" className="inputColor" min={0} step='any' value={cart[index].costDiscountPercentage}
                                onChange={(e) => handleRowChange(index, e.target.value, 'costDiscountPercentage')}
                                required
                            />
                        </Col>



                        {/* discount amount */}
                        <Col>
                            <Form.Control type="number" className="inputColor" min={0} step='any' value={cart[index].costDiscountAmount}
                                onChange={(e) => handleRowChange(index, e.target.value, 'costDiscountAmount')}
                                required
                            />
                        </Col>


                        {/* total cost */}
                        <Col>
                            <Form.Control type="number" name="total" id="total"
                                value={cart[index].totalCost}
                                disabled />
                        </Col>


                        {/* VAT % */}
                        <Col style={{ flex: 0.6 }}>
                            <Form.Control type="number" className="inputColor" min={0} step='any' value={cart[index].vatPercentage}
                                onChange={(e) => handleRowChange(index, e.target.value, 'vatPercentage')}
                                required
                            />
                        </Col>


                        {/* Details */}
                        <Col>
                            <Form.Control as="textarea" rows={1}
                                value={cart[index].details}
                                onChange={(e) => handleRowChange(index, e.target.value, 'details')}

                            />
                        </Col>


                        <Col className="d-flex justify-content-end" style={{ flex: 0.1 }}>
                            <FiEdit size={17} onClick={e => editProduct(cart[index].productId)}
                                style={{ cursor: 'pointer', color: '#2E70A5', marginTop: '11px', marginLeft: '10px' }} />
                        </Col>


                        <Col className="d-flex justify-content-end" style={{ flex: 0.1 }}>
                            <BiSolidTrash size={18} onClick={e => handleDeleteRowIndex(index)}
                                style={{ cursor: 'pointer', color: '#e6434f', marginTop: '10px' }} />
                        </Col>

                    </Row>




                ))}





                <Row className="mb-3">

                    <Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '10px' }}>
                        <FcPlus size={26} style={{ cursor: 'pointer' }} onClick={() => handleAddRow('cart')} />
                        <HiMinusCircle size={28} style={{ cursor: 'pointer' }} onClick={(e) => handleDeleteRow(e, 'cart')} />

                    </Col>

                </Row>

                <Row className="mb-3">

                    <Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '10px' }}>
                        <InputGroup style={{ backgroundColor: '#f0f8ff', width: '20%' }}>
                            <Form.Control type="text" placeholder='scan barcode to add ..'
                                value={scannedBarcode} onChange={e => setScannedBarcode(e.target.value)}
                                onKeyDown={(e) => { if (e.key === 'Enter') { handleBarcodeScan(e); } }} />
                            <InputGroup.Text><IoBarcodeOutline size={25} /></InputGroup.Text>
                        </InputGroup>
                    </Col>
                </Row>



                <Row className="mb-3">

                    <Form.Label>{formLanguages.Details}</Form.Label>
                    <Form.Control as="textarea"
                        name="details"
                        value={journalVoucher.details}
                        onChange={(e) => handleInputChange(e)} rows={2} />
                </Row>


            </div>



            {journalVoucher.isChargeAllocated &&
                <Row className="mb-3" style={{ marginTop: '50px' }}>
                    <Col md={5}>
                    </Col>
                    <Col md={2}>
                        {formLanguages.CartLockedMessage}
                    </Col>
                    <Col md={1}>
                        <FcLock size={35} />
                    </Col>
                </Row>
            }

        </div>

    )
}


export default InvoiceCart;